export const cifJo = ["301 151","<g fill-rule='nonzero' fill='none'><path fill='#000' d='M.5.5h300v150H.5z'/><path fill='#FFF' d='M.5 50.5h300v50H.5z'/><path fill='#007A3D' d='M.5 100.5h300v50H.5z'/><path fill='#CE1126' d='M150.5 75.5l-150 75V.5z'/><path fill='#FFF' d='M56.853 78.091l-6.392.596.842 6.385-4.45-4.641-4.451 4.641.843-6.385-6.392-.596 5.501-3.32-3.521-5.386 6.018 2.244 2.002-6.119 2.002 6.119 6.017-2.244-3.52 5.386z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-jo.js
// module id = null
// module chunks = 